/*
 * Home: pricing (sections/home-pricing.liquid). Boat-class picker, software
 * option and the buttons that depend on the boat.
 * - Total = seats x the per-seat price (sweep or sculling), from theme settings
 *   passed in <script type="application/json" data-pricing-config>. Team prices
 *   are USD amounts Shopify does not convert, so they are always shown in USD.
 * - Pro is suggested (tagged and preselected) for crews, Analytics for a 1x,
 *   until the visitor picks an option; after that their choice sticks.
 * - "Contact Our Team" hands the configuration to the homepage contact form
 *   through localStorage.xboat_team_config, the same payload as
 *   assets/team-configurator.js, and tells assets/contact-form.js to read it.
 */
(function () {
  var CLASSES = {
    '1x': { name: 'Single', kind: 'sculling', seats: 1 },
    '2x': { name: 'Double', kind: 'sculling', seats: 2 },
    '4x': { name: 'Quad', kind: 'sculling', seats: 4 },
    '2-': { name: 'Pair', kind: 'sweep', seats: 2 },
    '4-': { name: 'Four', kind: 'sweep', seats: 4 },
    '8+': { name: 'Eight', kind: 'sweep', seats: 8 }
  };

  function usd(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  function initPricing(root) {
    var configEl = root.querySelector('[data-pricing-config]');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var pills = root.querySelectorAll('[data-class]');
    var nameEl = root.querySelector('[data-pricing-name]');
    var mathEl = root.querySelector('[data-pricing-math]');
    var totalEl = root.querySelector('[data-pricing-total]');
    var proTag = root.querySelector('[data-pro-tag]');
    var proNote = root.querySelector('[data-pro-note]');
    var radios = root.querySelectorAll('[data-software]');
    var ctaCrew = root.querySelector('[data-cta="crew"]');
    var ctaSingle = root.querySelector('[data-cta="single"]');
    var contactBtn = root.querySelector('[data-pricing-contact]');

    var noteSuffix = proNote ? proNote.textContent.replace(/^\s*\$[\d,]+\s*/, '') : '';

    var state = { cls: '8+', software: null };

    function software() {
      var crew = state.cls !== '1x';
      return state.software || (crew ? 'pro' : 'analytics');
    }

    function render() {
      var c = CLASSES[state.cls];
      var per = c.kind === 'sweep' ? config.sweep : config.sculling;
      var crew = state.cls !== '1x';

      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', p.getAttribute('data-class') === state.cls ? 'true' : 'false');
      });

      if (nameEl) nameEl.textContent = c.name + ' (' + state.cls + ')';
      if (mathEl) mathEl.textContent = c.seats + ' ' + c.kind + (c.seats > 1 ? ' seats' : ' seat') + ' × ' + usd(per);
      if (totalEl) totalEl.textContent = usd(c.seats * per);
      if (proNote) proNote.textContent = usd(c.seats * config.subscription) + ' ' + noteSuffix;
      if (proTag) proTag.hidden = !crew;

      var sw = software();
      radios.forEach(function (r) { r.checked = r.value === sw; });

      if (ctaCrew) ctaCrew.hidden = !crew;
      if (ctaSingle) ctaSingle.hidden = crew;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        state.cls = p.getAttribute('data-class');
        render();
      });
    });

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) state.software = r.value;
      });
    });

    if (contactBtn) {
      contactBtn.addEventListener('click', function () {
        var c = CLASSES[state.cls];
        var per = c.kind === 'sweep' ? config.sweep : config.sculling;
        var pro = software() === 'pro';
        var planEl = root.querySelector('[data-software][value="' + software() + '"]');
        var planName = planEl ? planEl.getAttribute('data-name') : '';
        var payload = {
          sweepSeats: c.kind === 'sweep' ? c.seats : 0,
          scullingSeats: c.kind === 'sculling' ? c.seats : 0,
          totalSeats: c.seats,
          plan: planName,
          pricingModel: 'purchase',
          total: c.seats * per + (pro ? c.seats * config.subscription : 0),
          configSummary: c.name + ' (' + state.cls + '), ' + c.seats + ' ' + c.kind + (c.seats > 1 ? ' seats' : ' seat'),
          timestamp: Date.now()
        };
        try {
          localStorage.setItem('xboat_team_config', JSON.stringify(payload));
        } catch (e) {
          return;
        }
        document.dispatchEvent(new CustomEvent('xboat:team-config'));
      });
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-home-pricing]').forEach(initPricing);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
